export default __webpack_public_path__ + "static/media/earthling_8.ef3acd7d.png";